// 検索時のキャンセル表示までの時間
export const SEARCH_CANCEL_DISPLAY_TIME = 3000 // ミリ秒
